<template>
  <div class="layout">
    <div class="menu">
      <Menu topIndex="system"></Menu>
    </div>
    <div class="leftSide">
      <LeftSideBar current="system" leftIndex="user"></LeftSideBar>
    </div>
    <div id="deptContentBox" class="base-content">
      <!-- 上方按钮 -->
      <div>
        <el-button
          type="text"
          size="small"
          icon="el-icon-plus"
          @click="firstCreate()"
          >新增</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-close"
          @click="preCheck()"
          >删除</el-button
        >
      </div>
      <!-- 搜索 -->
      <div id="searchBox">
        <el-form ref="userForm" :model="userForm" label-width="80px">
          <el-form-item label="用户名">
            <el-input
              v-model="userForm.username"
              placeholder="请输入用户名"
            ></el-input>
          </el-form-item>
          <el-form-item label="真实姓名">
            <el-input
              v-model="userForm.realName"
              placeholder="请输入真实姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="所属机构">
            <!-- 组织机构树开始 -->
            <el-select
              ref="searchSelect"
              :value="SelectvalueTitleSearch"
              @clear="clearHandleSearch"
              placeholder="请选择所属组织机构"
              clearable
            >
              <el-option value="2" label="2">
                <el-tree
                  highlight-current
                  :expand-on-click-node="false"
                  ref="selectTreeSearch"
                  :data="optionData"
                  :props="treeProps"
                  :check-strictly="true"
                  :node-key="treeProps.value"
                  @node-click="changeCheckSearch"
                ></el-tree>
              </el-option>
            </el-select>
            <!-- 组织机构树结束 -->
          </el-form-item>
          <el-form-item label-width="0px">
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-search"
              @click="
                currentPage = 1;
                onSearch();
              "
              >查询</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <!-- 列表 -->
      <el-table
        :data="userTableData"
        style="width: 100%"
        border
        :header-cell-style="{ background: '#f8f8f8' }"
        @selection-change="handleTableSelectionChange"
      >
        <el-table-column
          type="selection"
          min-width="55"
          align="center"
        ></el-table-column>
        <el-table-column type="index" min-width="50" align="center">
        </el-table-column>
        <el-table-column
          prop="username"
          show-overflow-tooltip
          min-width="80"
          label="用户名"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="realName"
          min-width="80"
          label="真实姓名"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="phone"
          show-overflow-tooltip
          label="电话"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="dept.deptName"
          show-overflow-tooltip
          label="所属部门"
          align="center"
        >
        </el-table-column>

        <el-table-column show-overflow-tooltip label="操作" align="center">
          <template slot-scope="scope">
            <span class="right-add-button" @click="firstEdit(scope.row)"
              >【编辑】</span
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <div class="pagination-box">
        <el-pagination
          :current-page="currentPage"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 创建、编辑用户弹窗 -->
    <el-dialog title="新增用户" :visible.sync="createDialog" width="600px">
      <el-form ref="addUserForm" :rules="addUserRules" :model="addUserForm">
        <el-form-item label="用户名：" label-width="95px" prop="username">
          <el-input
            v-model="addUserForm.username"
            placeholder="请输入用户名"
          ></el-input>
        </el-form-item>
        <el-form-item label="真实姓名：" label-width="95px" prop="realName">
          <el-input
            v-model="addUserForm.realName"
            placeholder="请输入真实姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="所属机构：" label-width="95px" class="is-required">
          <!-- 获取部门树 -->
          <!-- 组织机构树开始 -->
          <el-select
            ref="addSelect"
            :value="SelectvalueTitle"
            placeholder="请选择所属组织机构"
            clearable
          >
            <el-option value="2" label="2">
              <el-tree
                highlight-current
                :expand-on-click-node="false"
                ref="selectTree"
                :data="optionData"
                :props="treeProps"
                :check-strictly="true"
                :node-key="treeProps.value"
                @node-click="changeCheck"
              ></el-tree>
            </el-option>
          </el-select>
          <!-- 组织机构树结束 -->
        </el-form-item>
        <el-form-item
          v-if="!isEdit"
          label="密码："
          label-width="95px"
          prop="password"
        >
          <el-input
            type="password"
            id="password"
            v-model="addUserForm.password"
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="!isEdit"
          id="password2"
          label="确认密码："
          label-width="95px"
          prop="checkPassword"
        >
          <el-input
            type="password"
            v-model="addUserForm.checkPassword"
            placeholder="请再次输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="isEdit"
          label="修改密码"
          prop="password"
          label-width="95px"
        >
          <el-input
            type="password"
            v-model="addUserForm.password"
            placeholder="请输入修改后密码(可不修改)"
            autocomplete="new-password"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="isEdit"
          label="确认密码"
          prop="checkPassword"
          label-width="95px"
        >
          <el-input
            type="password"
            v-model="addUserForm.checkPassword"
            placeholder="请确认修改后密码(可不修改)"
            autocomplete="new-password"
          ></el-input>
        </el-form-item>
        <el-form-item label="电话：" label-width="95px" prop="phone">
          <el-input
            v-model="addUserForm.phone"
            placeholder="请输入电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱：" label-width="95px" prop="phone">
          <el-input
            v-model="addUserForm.email"
            placeholder="请输入邮箱"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="createUser('addUserForm')"
          >确 定
        </el-button>
        <el-button @click="createDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 删除机构弹窗 -->
    <el-dialog title="删除用户" :visible.sync="deleteDialog" width="30%" center>
      <div>确定删除该用户？</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onDelete">确 定</el-button>
        <el-button @click="deleteDialog = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Menu from "../../menu/menu.vue";
import LeftSideBar from "../../menu/leftSideBar.vue";
import $ from "jquery";
import cookies from "vue-cookies";
export default {
  components: {
    Menu,
    LeftSideBar,
  },
  data() {
    var validateTelAdd = (rule, value, callback) => {
      if (value === "" || value == undefined) {
        callback();
      } else {
        if (
          (this.addUserForm.phone &&
            this.addUserForm.phone.toString().indexOf("-") !== -1) ||
          /^1[3456789]\d{9}$/.test(this.addUserForm.phone)
        ) {
          callback();
        }
        callback(new Error("请输入正确的电话格式"));
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "" || value === undefined) {
        if (this.isEdit) {
          callback();
        } else {
          callback(new Error("请输入密码"));
        }
      } else {
        if ($("#password").value) {
          //开启密码复杂度
          var regex = new RegExp(
            "(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,30}"
          );
          if (!regex.test(value)) {
            callback(
              new Error("密码必须同时包含大写、小写、数字和特殊字符且至少8位")
            );
            return;
          }
        }
        if (
          this.addUserForm.checkPassword !== "" &&
          this.addUserForm.checkPassword
        ) {
          this.$refs.addUserForm.validateField("checkPassword");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "" || value === undefined) {
        if (this.isEdit) {
          if (
            this.addUserForm.password == "" ||
            this.addUserForm.password == undefined
          ) {
            callback();
          } else {
            callback(new Error("请再次输入密码"));
          }
        } else {
          callback(new Error("请再次输入密码"));
        }
      } else if (value !== this.addUserForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        if ($("#password2").value) {
          //开启密码复杂度
          var regex = new RegExp(
            "(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,30}"
          );
          if (!regex.test(value)) {
            callback(
              new Error("密码必须同时包含大写、小写、数字和特殊字符且至少8位")
            );
            return;
          }
        }
        callback();
      }
    };
    return {
      multipleSelectionTable: [],
      isEdit: false,
      dataText: "",
      // 数据源
      userTableData: [],
      optionData: [],
      addUserForm: {
        id: "",
        username: "",
        realName: "",
        phone: "",
        deptName: "",
        password: "",
        checkPassword: "",
        email: "",
      },
      userForm: {
        username: "",
        realName: "",
        deptId: "",
      },
      // 组织机构树开始
      treeProps: {
        value: "id",
        label: "deptName",
        children: "children",
      },
      SelectvalueTitle: "",
      SelectvalueTitleSearch: "",
      // 分页
      currentPage: 1,
      pageSize: 10,
      totalSize: 50,
      // 弹窗
      createDialog: false,
      deleteDialog: false,
      // 规则
      addUserRules: {
        phone: [
          { validator: validateTelAdd, trigger: "blur" },
          { message: "请输入电话", trigger: "blur" },
        ],
        realName: [
          { required: true, message: "请输入真实姓名", trigger: "blur" },
        ],
        username: [
          { required: true, message: "请输入真实姓名", trigger: "blur" },
        ],
        password: [
          { required: true, validator: validatePass, trigger: "blur" },
        ],
        checkPassword: [
          { required: true, validator: validatePass2, trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    // 统一验证token
    var currentToken = cookies.get("token");
    $.ajaxSetup({
      headers: {
        AuthorizationToken: currentToken,
      },
      complete: function (xhr) {
        if (xhr.responseJSON.code == 401) {
          window.location.href = "/";
        }
      },
    });
    // 部门树开始
    let that = this;
    $.ajax({
      url: "/zyk/auth/deptInfo/treeList",
      type: "GET",
      contentType: "application/json;charset=utf-8",
      dataType: "json",
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.reload();
        }
      },
      success: function (response) {
        if (response.code == 200) {
          that.optionData = response.obj.list;
        } else {
          that.$message({
            message: response.msg,
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        }
      },
    });
    // 部门树结束
    this.searchParam();
  },
  methods: {
    // 搜索
    onSearch() {
      this.searchParam();
    },
    // 加载数据
    searchParam(deptId) {
      let that = this;
      let params = Object.assign({}, this.userForm);
      params.size = this.pageSize;
      params.page = this.currentPage;
      if (deptId) {
        params.deptId = deptId;
      }
      $.ajax({
        type: "GET",
        dataType: "json",
        url: "/zyk/c/auth/userInfo/list",
        data: params,
        contentType: "application/json;charset=utf-8",
        success: function (response) {
          if (response.code == 200) {
            var currentData = response.obj;
            if (currentData.totalSize == 0) {
              that.dataText = "暂无数据";
            }
            that.totalSize = currentData.total;
            that.userTableData = currentData.list;
            that.currentPage = currentData.pageNum;
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    // 显示新增弹框
    firstCreate() {
      this.createDialog = true;
      this.addUserTitle = "新增用户";
      this.isEdit = false;
      this.addUserForm = {
        id: "",
        username: "",
        realName: "",
        phone: "",
        deptName: "",
        password: "",
        checkPassword: "",
        email: "",
      };

      // 组织机构树开始
      this.SelectvalueTitle = "";
      // 组织机构树结束
    },
    // 显示修改弹框
    firstEdit(row) {
      this.addUserTitle = "修改用户";
      this.createDialog = true;
      this.isEdit = true;
      this.addUserForm = {
        username: row.username,
        realName: row.realName,
        phone: row.phone,
        deptName: row.dept.deptName,
        id: row.id,
        deptId: row.deptId,
      };
      this.SelectvalueTitle = row.dept.deptName;
    },
    // 新增、修改用户
    createUser(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          let url = "";
          if (!this.isEdit) {
            url = "/zyk/c/auth/userInfo/add";
            this.addUserTitle = "新增用户";
          } else {
            url = "/zyk/c/auth/userInfo/update";
            this.addUserTitle = "修改用户";
            delete this.addUserForm.username;
          }
          if (that.SelectvalueTitle == "") {
            that.$message({
              message: "请选择所属组织机构",
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
            return;
          }
          $.ajax({
            url: url,
            type: "POST",
            dataType: "json",
            data: this.addUserForm,
            error: function (xhr) {
              if (xhr.status == 401) {
                window.location.reload();
              }
            },
            success: function (data) {
              if (data.code == 200) {
                that.$message({
                  message: that.addUserTitle + "成功",
                  duration: 2000,
                  showClose: true,
                  type: "success",
                  offset: 100,
                });
                that.searchParam();
                that.createDialog = false;
              } else {
                that.$message({
                  message: data.msg,
                  duration: 0,
                  showClose: true,
                  type: "error",
                  offset: 100,
                  onClose: function () {
                    that.noClick = false;
                  },
                });
              }
            },
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删除前确认
    preCheck() {
      if (this.multipleSelectionTable.length == 0) {
        this.$message({
          message: "请选中用户",
          duration: 0,
          showClose: true,
          type: "error",
          offset: 100,
        });
      } else {
        this.deleteDialog = true;
      }
    },
    // 删除
    onDelete() {
      let ids = this.multipleSelectionTable.map((item) => {
        return item.id;
      });
      let that = this;
      // that.noClick = true;
      $.ajax({
        url: "/zyk/c/auth/userInfo/remove",
        type: "POST",
        //contentType: 'application/json;charset=utf-8',
        dataType: "json",
        data: { ids: ids.toString() },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          if (data.code == 200) {
            that.$message({
              message: "删除成功",
              duration: 2000,
              showClose: true,
              type: "success",
              offset: 100,
            });
            that.searchParam();
            that.deleteDialog = false;
          } else {
            that.$message({
              message: data.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
              onClose: function () {
                // that.noClick = false;
              },
            });
          }
        },
      });
    },
    // 选择表格某一行
    handleTableSelectionChange(val) {
      this.multipleSelectionTable = val;
    },
    // 树形组件的值发生改变
    changeCheck(node) {
      this.addUserForm.deptId = node.id;
      this.addUserForm.deptName = node.deptName;
      this.SelectvalueTitle = node.deptName;
      this.$refs.selectTree.setCurrentKey(node.id);
      this.$refs.addSelect.blur();
    },
    // 清除选中
    clearHandle() {
      this.SelectvalueTitle = "";
      delete this.addUserForm.deptId;
      this.$refs.selectTree.setCurrentKey(null);
    },
    //  新增部门树结束
    // 查询部门树开始
    changeCheckSearch(node) {
      this.userForm.deptId = node.id;
      this.SelectvalueTitleSearch = node.deptName;
      this.$refs.selectTreeSearch.setCurrentKey(node.id);
      this.$refs.searchSelect.blur();
    },
    clearHandleSearch() {
      this.SelectvalueTitleSearch = "";
      delete this.userForm.deptId;
      this.$refs.selectTreeSearch.setCurrentKey(null);
    },
    // 查询部门树结束

    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.searchParam();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchParam();
    },
  },
};
</script>

<style>
.el-dialog .el-form {
  padding: 10px 20px;
}
</style>